import { AvailableWinDisplay } from "@lib/titan2-slingo/dist/game/view/abstract/display/AvailableWinDisplay";
import { TitanSprite } from "@lib/titan2/dist/game/control/TitanSprite";
import { TitanText } from "@lib/titan2/dist/game/control/TitanText";
import { Logger } from "@lib/titan2/dist/util/log/Logger";
import { gsap } from "gsap";
import { PixiPlugin } from "gsap/all";
import * as PIXI from "pixi.js";
import { GameEvent } from "../../../controller/event/GameEvent";
import { GameTweenConstants } from "../constant/GameTweenConstants";
gsap.registerPlugin(PixiPlugin);
/**
 * GameAvailableWinDisplay.ts
 */
export class GameAvailableWinDisplay extends AvailableWinDisplay {
    createProperties(properties, portraitProperties) {
        super.createProperties(properties, portraitProperties);
        this.landscapeProperties = properties;
        this.portraitProperties = portraitProperties;
    }
    create() {
        this.createModel();
        this.createMouseBlocker();
        this.createAvailableWinText();
        Logger.addObjectRef(this, "AvailableWinDisplay");
    }
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(GameEvent.HELP_HIDE_BASEGAME, this.hide);
        this.registerGame(GameEvent.HELP_SHOW_BASEGAME, this.show);
    }
    handleAvailableWin() {
        this.showAvailableWinText();
        gsap.delayedCall(GameTweenConstants.AVAILABLE_WIN_POPUP_DURATION, () => this.hideAvailableWinText());
    }
    createAvailableWinText() {
        this.availableWinTextHolder = new PIXI.Container();
        this.background = TitanSprite.createSprite(this.availableWinTextHolder, "background", this.landscapeProperties.backgroundProperties, this.portraitProperties?.backgroundProperties);
        this.labelOnTheNextSpin = TitanText.createField(this.availableWinTextHolder, this.landscapeProperties.labelOnTheNextSpinProperties, this.portraitProperties?.labelOnTheNextSpinProperties);
        this.labelYouCouldWin = TitanText.createField(this.availableWinTextHolder, this.landscapeProperties.labelYouCouldWinProperties, this.portraitProperties?.labelYouCouldWinProperties);
        this.availableWinField = TitanText.createField(this.availableWinTextHolder, this.landscapeProperties.availableWinFieldProperties, this.portraitProperties.availableWinFieldProperties);
        this.availableWinTextHolder.position.set(this.uiProperties.availableWinTextHolderPosition.x, this.uiProperties.availableWinTextHolderPosition.y);
        this.availableWinTextHolder.visible = false;
        this.addChild(this.availableWinTextHolder);
    }
    showAvailableWinText() {
        if (this.model.isStakeToSpin()) {
            return;
        }
        const availableWin = this.model.getAvailableWin();
        this.availableWinField.setText(this.formatCurrency(availableWin.getWinAmount()));
        gsap.killTweensOf(this.availableWinTextHolder);
        gsap.to(this.availableWinTextHolder, {
            pixi: { scaleX: this.uiProperties.availableWinTextHolderScale.x, scaleY: this.uiProperties.availableWinTextHolderScale.y, autoAlpha: 1 },
            duration: GameTweenConstants.AVAILABLE_WIN_SHOW_DURATION,
            ease: "back.out(0.5)"
        });
    }
    handleRotate(event) {
        const data = event?.getCurrentTarget() || {};
        this.uiProperties = this.getCurrentProperties(data.forceOrientation);
        if (this.responsive) {
            this.layouts = [];
            this.applyProperties();
        }
        this.availableWinTextHolder.position.set(this.uiProperties.availableWinTextHolderPosition.x, this.uiProperties.availableWinTextHolderPosition.y);
        this.availableWinTextHolder.scale.set(this.uiProperties.availableWinTextHolderScale.x, this.uiProperties.availableWinTextHolderScale.y);
    }
    hideAvailableWinText() {
        if (this.model.isStakeToSpin()) {
            return;
        }
        gsap.killTweensOf(this.availableWinTextHolder);
        gsap.to(this.availableWinTextHolder, {
            pixi: { autoAlpha: 0 },
            duration: GameTweenConstants.AVAILABLE_WIN_FADE_DURATION,
            ease: "none",
            onComplete: this.hideAvailableWinTextComplete,
            callbackScope: this
        });
    }
    showAvaliableWinOverlay() {
        if (this.mouseBlocker) {
            this.mouseBlocker.alpha = 0;
            this.addChildAt(this.mouseBlocker, 0);
            gsap.to(this.mouseBlocker, { duration: 0.25, alpha: 0.4 });
        }
    }
}
//# sourceMappingURL=GameAvailableWinDisplay.js.map